import * as moment from 'moment';

export class Logger {
    public static error(msg: string, ...optionalParameters: any[]): void {
        console.error(`[${this.timestamp()}] [ERROR] ${msg}`, optionalParameters);
    }

    public static log(msg: string): void {
        console.log(`[${this.timestamp()}] [INFO] ${msg}`);
    }

    private static timestamp(): string {
        return moment().format(`YYYY-MM-DDTHH:mm:ss.sss`);
    }
}